import ColorMenu from './colorMenu'
import { connect } from 'react-redux'
import { changeColor, addColorScheme, selectColor, selectTile, selectSample, addColor } from '../../actions/index'

const mapStateToProps = (state, props) => ({
	colors: state.colors,
	selectedPath: state.selectedPath,
	selectedColor: state.selectedColor,
	currentColors: state.currentColors,
	selectedTile: state.selectedTile
})

const mapDispatchToProps = (dispatch, props) =>({
	onSelectColor : ( pathId, color, colorId ) => { dispatch( changeColor( pathId, color ) ); dispatch(selectColor(colorId))},
	onAddColor : color => dispatch(addColor(color)),
	onAddColorScheme: ( tileId, colors ) => { dispatch ( addColorScheme( tileId, colors ) ); dispatch(selectSample(0)); /*dispatch(selectTile(id));*/ }
})

const VisibleColorMenu = connect( mapStateToProps, mapDispatchToProps )(ColorMenu);

export default VisibleColorMenu;


// WEBPACK FOOTER //
// ./src/components/mosaic/visibleColorMenu.jsx